import "../../assets/css/postSale.css"
import circleImg from "../../assets/images/circle (1).svg"
import fox from "../../assets/images/arts/fox1.jpg"

const RoadMap = () => {
    return (
        <div className="bg-road py-4" id="roadMap">
            <div className="container">
                <div className="row pb-3 justify-content-center align-items-center">
                    <div className="circle-container">
                        <img className="circleImg" src={circleImg} alt="" />
                     <div className="art-img-wrap">
                       <img src={fox} alt="" className="art-img" />

                     </div>
                        <div className="top-content">
                        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque dignissimos laudantium autem! Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestias, dolor illum natus dolore totam tenetur?</p>
                        </div>
                        <div className="left-content">
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque dignissimos laudantium autem! Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestias, dolor illum natus dolore totam tenetur?</p>
                        </div>
                        <div className="right-content">
                        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Itaque dignissimos laudantium autem! Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestias, dolor illum natus dolore totam tenetur?</p>
                        </div>
                    </div>


                    {/* <div className="col-12 pt-3 pb-5 mb-3">
                        <h1 className="sec-heading  text-white py-md-0 pt-2 text-center">Road Map</h1>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <Card heading="25%" bodyText="G-Fox  Lorem ipsum, dolor sit adipisicing elit. dolor sit adipisicing elit." />
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <Card heading="50%" bodyText="G-Fox  Lorem ipsum, dolor sit adipisicing elit. dolor sit adipisicing elit." />
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <Card heading="100%" bodyText="G-Fox  Lorem ipsum, dolor sit adipisicing elit. dolor sit adipisicing elit." />
                    </div> */}
                </div>
            </div>
        </div>
    )
}


const Card = (props) => {
    return (
        <div className="price-card">
            <div className="cardheading">
                <h5>{props.heading}</h5>
            </div>
            <div className="price-card-body">
                <p>{props.bodyText}</p>
            </div>
        </div>
    )
}

export default RoadMap
